module.exports = __webpack_public_path__ + "img/val-icon-3.7e601012.svg";